module.exports = __webpack_public_path__ + "static/media/pyv-edit-delete-select-pyv-click-yes.b7459240.gif";